import React, {useEffect, useState} from 'react';
import axios from "../../../helpers/axios";
import {Portlet, PortletBody} from "../../../components/Portlet";
import SearchSelect from "../../../components/searchSelect";
import ApiSelect from "../../base/components/forms/apiSelect";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import {Form, InputGroup} from "react-bootstrap";
import DateToFromPicker from "./dateToFromPicker";
import Loader from "../../../components/loader";
import BlockUi from "@availity/block-ui";
import {all} from "axios";
import {useController, useForm} from "react-hook-form";
import _ from "lodash";
import Button from "react-bootstrap/Button";


const tempQuery = {
  serviceType:null,
  buyer:null,
  paid:'',
  foundInCash:'',
  supplier:null,
  deleted:false,
  forPaiments: false,
  standartSort: true,
  createdBy:null,
  onlyBadKrs:false
}
const ListOptions = ({query, setQuery, all, setAll}) => {
  const [clear, setClear] = useState(false)
  const [options, setOptions]=useState({
    types:null,
    issuedBy:null,
    createdBy:null,
    buyer:null,
    supplier:null,
    city:null,
    country:null,
    onlyBadKrs:false
  })
  const [typeCity, setTypeCity] = useState(true)


  useEffect(() => {
    axios.post('/api/touristServices/typesSelect')
      .then(({data})=>{
        setOptions(o=>({...o,types: data.data}))
      })
    axios.post('/api/touristServices/createdBySelect')
      .then(({data})=>{
        setOptions(o=>({...o,createdBy: data.data}))
      })

    axios.post('/api/users/emplSearch',{operatorOneS:true})
      .then(({data})=>{
        setOptions(o=>({...o,issuedBy: data.data.map(e=>({label:e.label, value:e.value._id}))}))
      })

    axios.post('/api/counterparty/searchInput', )
      .then(({data})=>{
        setOptions(o=>({...o, buyer: data.data}))
      })
    axios.post('/api/counterparty/suppliers/getAll',{type: 'service'})
      .then(({data})=>{
        setOptions(o=>({...o, supplier: data.data}))
      })

  }, []);
  const optionsReady = options.types && options.issuedBy && options.buyer && options.createdBy && options.supplier
  return (
    <BlockUi blocking={!optionsReady}><Portlet style={{minHeight : "139.78px"}}>
      <PortletBody>
        {optionsReady && <form>
        <div className={'d-flex gap-2 mb-3'}>
          <div style={{position: 'relative', width:'13rem'} }>
            <label className={'absolutLabel'}>Имя</label>
            <Form.Control
              name={'search'}
              defaultValue={query.pax}
              value={query.pax || ''}
              onChange={(e) => setQuery(q => ({...q, pax: e.target.value}))}
              className={'form-control'}
              type={'text'}
              placeholder="Турист,отель, маршрут"
            />
          </div>
          <div style={{width: '12rem'}}>
            <SearchSelect
              onChange={(v) => {
                setQuery(q => ({...q, serviceType: v}))
              }}
              defaultValue={query.serviceType}
              label={'Тип услуг'}
              unregister
              array={[{value: null, label: 'Все'}, ...options.types]}/>
          </div>
          <div style={{width: '14rem'}}>
            <SearchSelect
              onChange={v => {
                console.log('v', v)
                setQuery(q => ({...q, buyer: v}))
              }}
              defaultValue={query.buyer}
              label={'Покупатель'}
              unregister
              array={[{value: '', label: 'Все'}, ...options.buyer]}/>
          </div>
          <DateToFromPicker label={'Дата выписки'}
                            clear={clear}
                            width={'19rem'}
                            defaultValue={query.issueDate ? {start:query.issueDate[0],
                              end:query.issueDate[1]} :{}}
                            setOptions={(v)=>{
            setQuery(q=>({...q, issueDate: v}))
          }}/>
          <DateToFromPicker label={'Дата услуг'}
                            width={'19rem'}
                            defaultValue={query.execDate ? {start:query.execDate[0],
                              end:query.execDate[1]} :{}}
                            clear={clear}
                            setOptions={(v)=>{
            setQuery(q=>({...q, execDate: v}))
          }}/>
          <div style={{width: '7rem'}}>
            <SearchSelect
              onChange={(v) => {
                setQuery(q => ({...q, paid: v}))
              }}
              defaultValue={query.paid}
              label={"Оплачено"}
              unregister
              array={[{value: '', label: 'Все'}, {value: false, label: 'Нет'}, {
                value: true,
                label: 'Да'
              }]}/>
          </div>
        </div >
          <div className={'d-flex gap-2 justify-content-between align-items-center'}>
            <div className={'d-flex gap-2'}>
              <div style={{width: '9rem'}}>
                <SearchSelect
                  onChange={(v) => {
                    setQuery(q => ({...q, issuedBy: v}))
                  }}
                  defaultValue={query.issuedBy}
                  unregister
                  label={'Выписал'}
                  array={[{value: null, label: 'Все'}, ...options.issuedBy]}/>
              </div>
              <div style={{width: '9rem'}}>
                <SearchSelect
                  onChange={(v) => {
                    setQuery(q => ({...q, createdBy: v}))
                  }}
                  defaultValue={query.createdBy}
                  unregister
                  label={'Создал'}
                  array={[{value: null, label: 'Все'}, ...options.createdBy]}/>
              </div>

              <div style={{width: '6.5rem'}}>
                <SearchSelect
                  onChange={(v) => {
                    setQuery(q => ({...q, documents: v}))
                  }}
                  defaultValue={query.documents}
                  unregister
                  label={"Документы"}
                  array={docArray}/>
              </div>
              <div style={{width: '10.5rem'}}>
                <SearchSelect
                  onChange={v => {
                    console.log('v', v)
                    setQuery(q => ({...q, supplier: v}))
                  }}
                  defaultValue={query.supplier}
                  unregister
                  label={'Поставщик'}
                  array={[{value: '', label: 'Все'}, ...options.supplier]}/>
              </div>
              <div style={{position: 'relative', width: '10.5rem'}}>
                <label className={'absolutLabel'}>Индив. код</label>
                <Form.Control
                  name={'idInOneC'}
                  defaultValue={query.idInOneC}
                  value={query.idInOneC || ''}
                  onChange={(e) => setQuery(q => ({...q, idInOneC: e.target.value}))}
                  className={'form-control'}
                  type={'text'}
                  placeholder="Поиск..."
                />
              </div>
              <div style={{width: '6.5rem'}}>
                <SearchSelect
                  onChange={(v) => {
                    setQuery(q => ({...q, foundInCash: v}))
                  }}
                  defaultValue={query.foundInCash}
                  label={"Google"}
                  unregister
                  array={[{value: '', label: 'Все'}, {value: false, label: 'Нет'}, {
                    value: true,
                    label: 'Найден'
                  }]}/>
              </div>
              <div>
                <InputGroup>
                  <div style={{width: '10rem'}}>
                    <ApiSelect
                      value={typeCity ? query.city : query.country}
                      url={typeCity ? "/api/locations/cities/searchInput" : '/api/locations/countries/searchInput'}
                      label={typeCity ? 'Город' : 'Страна'}
                      cb={newVal => {
                        setQuery(q => ({
                          ...q,
                          [typeCity ? 'city' : 'country']: newVal,
                          [typeCity ? 'country' : 'city']: undefined
                        }))
                      }}
                    />
                  </div>
                  <Button variant="outline-secondary" size={'sm'} onClick={() => {
                    setTypeCity(!typeCity)
                  }}>
                    {typeCity ? 'Г' : 'С'}
                  </Button>
                </InputGroup>
              </div>
              <div>
                <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
                  <input
                    defaultChecked={query.deleted}
                    checked={!!query.deleted}
                    onChange={(e) => {
                      setQuery(q => ({...q, deleted: e.target.checked}))
                    }}
                    type={"checkbox"}
                  />{" "}
                  Удаленные
                </Form.Label>
                <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
                  <input
                    defaultChecked={query.onlyBadKrs}
                    checked={!!query.onlyBadKrs}
                    onChange={(e) => {
                      setQuery(q => ({...q, onlyBadKrs: e.target.checked}))
                    }}
                    type={"checkbox"}
                  />{" "}
                  3300
                </Form.Label>
                <Form.Label className={'d-flex align-items-center gap-2'}>
                  <input
                    defaultChecked={all}
                    checked={all}
                    onChange={(e) => {
                      setAll(!all)
                    }}
                    type={"checkbox"}
                  />{" "}
                  Все
                </Form.Label>
              </div>
            </div>
            <div className={'d-flex flex-column align-items-end'}>
              <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
                Для оплат
                <input
                  defaultChecked={query.forPaiments}
                  checked={query.forPaiments}
                  onChange={(e) => {
                    setQuery(q => ({...q, forPaiments: e.target.checked, standartSort: !e.target.checked}))
                  }}
                  type={"checkbox"}
                />
              </Form.Label>
              <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
                Стандартная сортировка
                <input
                  defaultChecked={query.standartSort}
                  checked={query.standartSort}
                  onChange={(e) => {
                    setQuery(q => ({...q, standartSort: e.target.checked}))
                  }}
                  type={"checkbox"}
                />
              </Form.Label>

              <div className={'pointer'} onClick={() => {
                setQuery(tempQuery)
                setClear(true)
                setAll(false)
                setTimeout(() => setClear(false), 1000)
              }}>
                Очистить фильтр <i className={"fa fa-times-circle text-danger"}/>
              </div>
            </div>

          </div>
        </form>}
      </PortletBody>
    </Portlet>
    </BlockUi>
  );
};

export default ListOptions;

const docArray = [
  {value: '', label: 'Все'},
  {value: 'withDocs', label: 'C док.'},
  {value: 'withoutDocsAndRustar', label: 'Без'},
  {value: 'withoutDocs', label: 'Без с рустаром'}
]
